import React, {FC} from 'react'
import { TablesReclamaciones } from './Reclamaciones/TablesReclamaciones'


const Reclamaciones: FC = () => {
  return (
    <>
      <TablesReclamaciones className='mb-5 mb-xl-8' />
    </>
  )
}

export {Reclamaciones}
